
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/goal/[goalSlug]/[goalUID]/practice/topics/[topicUID]",
      function () {
        return require("private-next-pages/goal/[goalSlug]/[goalUID]/practice/topics/[topicUID]/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/goal/[goalSlug]/[goalUID]/practice/topics/[topicUID]"])
      });
    }
  